import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Header from '../Header/Header';
import { getStyles } from './styles';
import PermissionsPanel from './PermissionsPanel';
import PermissionsSheet from './PermissionsSheet';
import { PermissionCode, UserRole } from '@beable/roster-backend-client-v1';
import { SiteDTO } from '@beable/roster-backend-client-v1';

export default function CustomerPermissions() {
  const [siteId, setSiteId] = useState<number | undefined>(undefined);
  const [permission, setPermission] = useState<PermissionCode | undefined>(undefined);
  const [role, setRole] = useState<UserRole | undefined>(undefined);
  const theme = useTheme();
  const styles = getStyles(theme);

  const handleSiteSelect = (site: SiteDTO): void => {
    setSiteId(site?.id)
  }

  const handlePermissionSelect = (permission: PermissionCode): void => {
    setPermission(permission)
  }

  const handleRoleSelect = (role: UserRole): void => {
    setRole(role)
  }

  return (
    <Box sx={styles.root}>
      <Header />
      <PermissionsPanel
        onSiteSelect={handleSiteSelect}
        onPermissionSelect={handlePermissionSelect}
        onRoleSelect={handleRoleSelect}
      />
      <PermissionsSheet siteId={siteId} permissionCode={permission} role={role} />
    </Box>
  );
}